import { KeyRound, Banknote, Wrench, Truck, ShieldCheck, HeartHandshake } from "lucide-react";

export const ROLES = [
  { value: "admin", label: "Admin" },
  { value: "regional_manager", label: "Regional Manager" },
  { value: "community_manager", label: "Community Manager" },
  { value: "maintenance_tech", label: "Maintenance Tech" },
];

export const ROLE_LABEL = { super_admin: "Super Admin", ...Object.fromEntries(ROLES.map((r) => [r.value, r.label])) };

export const ROLE_STYLE = {
  super_admin: "bg-lasso-ink text-amber-300",
  admin: "bg-lasso-ink text-white",
  regional_manager: "bg-lasso-navy text-white",
  community_manager: "bg-lasso-sky text-lasso-ink",
  maintenance_tech: "bg-lasso-tint text-lasso-deep border border-lasso-sky/60",
};

export const CATEGORIES = [
  { value: "Leasing", icon: KeyRound },
  { value: "Rent Collection", icon: Banknote },
  { value: "Maintenance", icon: Wrench },
  { value: "Move-In/Move-Out", icon: Truck },
  { value: "Compliance & Safety", icon: ShieldCheck },
  { value: "Resident Relations", icon: HeartHandshake },
];

export const CATEGORY_ICON = Object.fromEntries(CATEGORIES.map((c) => [c.value, c.icon]));

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/b23e97ae-7ec8-440b-91d6-4523fbfcd64c/images/6ccbab2a992fb7bc998797ae43683af078671ed30c4857dd8d8b6d69339dd9a5.jpeg",
  team: "https://static.prod-images.emergentagent.com/jobs/b23e97ae-7ec8-440b-91d6-4523fbfcd64c/images/27a7f1503c3fcf656674d086fa07270aa29abdcab76182b3de4075b9d7239697.jpeg",
  field: "https://static.prod-images.emergentagent.com/jobs/b23e97ae-7ec8-440b-91d6-4523fbfcd64c/images/2061e502c7c76b176de3a7ba7df57ccb8d0a79442f24fecd2bb01c9d8a18cac0.jpeg",
};

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
